import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {VisualHistoryEventListItemFragment} from 'molbio/visual-history/__generated/VisualHistoryEventListItemFragment';
import VisualHistoryEventListItem from 'molbio/visual-history/VisualHistoryEventListItem';
import {GRAY_DARKER} from 'ui-library/Colors';

export interface VisualHistoryEventListProps {
  events: Array<VisualHistoryEventListItemFragment>;
  onClickVersion: (entityVersionId: string) => void;
}

/**
 * Render a list of visual history events with an arrow running up the left side of the list.
 * @param events List of visual history event data.
 * @param onClickVersion Callback executed when a specific version is clicked.
 * @constructor
 */
export default function VisualHistoryEventList({
  events,
  onClickVersion,
}: VisualHistoryEventListProps): JSX.Element {
  const listItems = events.map((event, index) => (
    <VisualHistoryEventListItem key={index} event={event} onClickCreatedAt={onClickVersion} index={index} />
  ));
  return <div className={css(styles.listContainer)}>{listItems}</div>;
}

const styles = StyleSheet.create({
  listContainer: {
    borderLeft: `2px solid ${GRAY_DARKER}`,
    padding: '16px 0',
    // Renders a triangle at the top of the left border, making the left border look like an arrow
    '::before': {
      position: 'absolute',
      left: '29px',
      top: '6px',
      content: '""',
      borderTop: '2px solid transparent',
      borderBottom: `12px solid ${GRAY_DARKER}`,
      borderLeft: '6px solid transparent',
      borderRight: '6px solid transparent',
    },
  },
});
